import { toast, ToastContainer } from 'react-toastify';

import Modal from 'react-modal'
import { useEffect, useState } from "react";
import loading from "../../assets/images/loading.gif"
import { makeDeleteRequest, makeGetRequest, makePatchRequest, makePostRequest } from '../../request';
import { Users, Roles } from '../../interfaces/index.types';
import Pagination from '../../components/Pagination';
import Layout from '../Layout';
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from '@mui/material/TextField';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { addSpacesToPascalCase, TRTThirdPartyRoles, TRTTotalRoles } from 'helpers';

const filterOptions = createFilterOptions({ limit: 100 });


const UserManagement =  () => {   
    const [selectedValue, setSelectedValue] = useState<string[]>([]);
    const [formData, setFormData] = useState<Record<string, any>>({
        email: "",
        fullname: "",
        firstName: "",
        lastName: "",        
        category: "",
        roleIds: [],
        companyName: "",
        department: "",
        vendorCode: ""
    })

    // All roles visible to transit
    const TRTRoles = [...TRTTotalRoles, ...TRTThirdPartyRoles]

    const [errorData, setErrorData] = useState<Record<string, any>>({})
    const [activity, setActivity] = useState("")
    const [userId, setUserId] = useState("")
    const [CreateUserModal, setCreateUserModal] = useState(false)
    const [CreateUserModal1, setCreateUserModal1] = useState(false)
    const [updateUserModal, setUpdateUserModal] = useState(false)
    const [deleteUserModal, setDeleteUserModal] = useState(false)
    const [toggleActiveUser, setToggleActiveUser] = useState(false)
    const [updateUserRoleModal, setUpdateUserRoleModal] = useState(false)

    const customStyles = {
        overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }
    }; 

    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const totalPages = Math.ceil(totalItems / itemsPerPage);

    const [startIndex, setStartIndex] = useState(0);
    const getPageNumbers = () => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
            if (currentPage >= startIndex + 4) {
                setStartIndex(startIndex + 4);
            }
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
            if (currentPage - 1 <= startIndex) {
                setStartIndex(startIndex - 4);
            }
        }
    };

    const clearFormData = () => {
        setFormData({
            firstName: "",
            lastName: "",
            email: "",
            category: "",
            roleIds: [],
            // companyName: "",
            // department: ""
        })
        setVendorList([])
        setErrorData([])
        // setSelectedRoles([])
        setSelectedValue([])
    }

    const handleOpenModal = (modal: any) => {
        switch(modal){
            case "CreateUserModal":
                clearFormData()
                getAllRoles()
                setCreateUserModal(true)
                break

            case "CreateUserModal1":
                clearFormData()
                getAllRoles()
                setCreateUserModal1(true)
                break

            case "UpdateUserModal":
                setUpdateUserModal(true)
                getAllRoles()
                setErrorData([])
                break

            case "updateUserRoleModal":
                setUpdateUserRoleModal(true)
                break

            case "ToggleActiveUser":
                setToggleActiveUser(true)
                break

            case "DeleteUser":
                setDeleteUserModal(true)
                break

            default:
                break
        }
    }

    const handleCloseModal = (modal: any) => {
        switch(modal){
            case "CreateUserModal":
                setCreateUserModal(false)
                clearFormData()
                break

            case "UpdateUserModal":
                setUpdateUserModal(false)
                clearFormData()
                break

            case "updateUserRoleModal":
                setUpdateUserRoleModal(false)
                break

            case "ToggleActiveUser":
                setToggleActiveUser(false)
                setActivity("")
                setUserId("")
                break

            case "DeleteUser":
                setUserId("")
                setDeleteUserModal(false)
                break

            case "":

                break

            default:
                break
        }
    }
    const [users, setUsers] = useState<Users[]>()
    const [roles, setRoles] = useState<Roles[]>()
    // const [filterCategoryValue, setFilterCategory] = useState("")
    const [filterRoleValue, setFilterRole] = useState("")
    const [searchValue, setSearchValue] = useState("")

    const [isLoading, setIsLoading] = useState(false)
    const [isLoading2, setIsLoading2] = useState(false)
    const getAllUsers = () => {
        setIsLoading(true)
        var request: Record<string, any> = {
            what: !filterRoleValue ? "getAllUsers" : "getAllUsersForARole",
            params: {
                Page: currentPage,
                PageSize: itemsPerPage,
                // conditional roleName key
                ...(!filterRoleValue && {Role: "TransitOfficer"}),
                ...(filterRoleValue && {RoleName: filterRoleValue})
            }
        };
        if(searchValue) request.params.SearchString = searchValue
        // if(filterCategoryValue) request.params.Category = filterCategoryValue
        
        makeGetRequest(request)
            .then((response: any) => {
                setIsLoading(false)
                const res = response.data.data
                setUsers(res)
                console.log(res)
                setTotalItems(response.data.totalCount)
            })
            .catch((error:any) => 
                toast.error(error.errorMessage)
            );
    }

    const getAllRoles = () => {
        var request: Record<string, any> = {
            what: "getAllRoles",
        };
        
        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                setRoles(res)
            })
            .catch((error:any) => toast.error(error.msg));
    }

    const [isSubmitting, setIsSubmitting] = useState(false)
    const DeleteUser = () => {
        var request: Record<string, any> = {
            what: "DeleteUser",
            params: {
                Email: userId
            }
        };
        
        setIsSubmitting(true)
        makeDeleteRequest(request)
            .then((response: any) => {
                setIsSubmitting(false)
                handleCloseModal("DeleteUser")
                toast.success(response.msg)
                getAllUsers()
            })
            .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
    }
    const ActivateDeactivateUser = () => {
        var request: Record<string, any> = {
            what: activity === "activate" ? "ActivateUser" : "DeactivateUser",
            params: {
                userId: userId
            }
        };
        setIsSubmitting(true)
        makePatchRequest(request)
            .then((response: any) => {
                setIsSubmitting(false)
                toast.success(response.msg)
                handleCloseModal("ToggleActiveUser")
                getAllUsers()
            })
            .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
    }

    const getUser = (id:string) => {
        const user = users?.find(user => user.id === id)
          
        setFormData({
            id: user?.id,
            firstName: user?.firstName,
            lastName: user?.lastName,
            email: user?.email,
            category: user?.category,
            roles: user?.roles,
            selectedRoleForUpdate: "",
            companyName: user?.companyName,
            department: user?.department,
            entityDepartment: user?.department?.split(";")[2] ? user?.department?.split(";")[2]?.trim() : "", 
            // vendorCode: user?.vendorCode
        })
        setSelectedValue(user?.roles)
    }

    // const HandleOnboardUser = () => {     
    //     var isCompanyNameSet, isAddressSet;    
      
    //     if (formData.category === "THIRDPARTY" && !formData.companyName) {
    //         isCompanyNameSet = false
    //         setErrorData({ ...errorData, companyName: 'This field is required' });
    //     } else isCompanyNameSet = true

    //     if (formData.category === "THIRDPARTY" && !formData.address) {
    //         isAddressSet = false
    //         setErrorData({ ...errorData, address: 'This field is required' });
    //     } else isAddressSet = true
        
    //     if(isCompanyNameSet && isAddressSet) {  
    //         setIsSubmitting(true)          
    //         setErrorData({ ...errorData, companyName: '' })            
    //         let data:any = {
    //             firstName: formData.firstName,
    //             lastName: formData.lastName,
    //             email: formData.email,
    //             ...(formData.category === "THIRDPARTY" && {
    //                 vendorCode: formData.vendorCode,
    //                 address: formData.address,
    //                 companyName: formData.companyName
    //             }),
    //             category: formData.category,
    //         }
    //         data.department = formData.department
            
    //         if (Object.values(data).every(value => value)){            
    //             var request:Record<string, any> = {
    //                 what: "OnboardUser",
    //                 data: data
    //             };             
    //             makePostRequest(request)
    //                 .then((response: any) => {  
    //                     setIsSubmitting(false)          

    //                     toast.success(response.msg)
    //                     handleCloseModal('CreateUserModal')  // close modal 
    //                     // display the newly added user 
    //                     setSearchValue(response.data.data.user.email)      
    //                     getAllUsers() 
    //                 })
    //                 .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false)});
    //         }else {
    //             toast.warning("Please provide information for all required fields")
    //         }
    //     }       
    // }

    const HandleEditUser = () => {               
        setIsSubmitting(true)    
        setErrorData({ ...errorData, companyName: '' })            
        let data:any = {
            firstName: formData.firstName,
            lastName: formData.lastName,
            email: formData.email,
            roles: formData.roles,
        }

        if (Object.values(data).every(value => value)){
            data.companyName = formData.companyName
            data.address = formData.address
            data.department = formData.department
            
            var request:Record<string, any> = {
                what: "UpdateUser",
                data: data,
                params: {
                    userId: formData.id
                }
            };             
            makePatchRequest(request)
                .then((response: any) => {    
                    setIsSubmitting(false)                 
                    toast.success(response.msg)
                    handleCloseModal('UpdateUserModal')  // close modal    
                    setSearchValue(response.data.user.email)
                })
                .catch((error:any) => {toast.error(error.msg); setIsSubmitting(false) });
        }       
    }

    const handleChange = (event: any) => {        
        const { name, value } = event.target //get data form each input on change
        // if(name === "category") setSelectedRoles([]); 
        setFormData(values => ({...formData, [name]: value})) //set retrieved values to "formData" object 
    }

    const handleCopy = (text: string) => {
        // Implement the copy logic here
        const tempTextArea = document.createElement("textarea");
        tempTextArea.value = text;
    
        // Make the textarea non-editable to avoid focus and activation
        tempTextArea.setAttribute("readonly", "");
        tempTextArea.style.position = "absolute";
        tempTextArea.style.left = "-9999px";
    
        document.body.appendChild(tempTextArea);
        tempTextArea.select();
    
        try {
            // Copy the text to the clipboard
            document.execCommand("copy");
            toast.info(`Copied! - ${text}`)
        } catch (err) {
            toast.error("Unable to copy selected item: " + err);
        } finally {
            document.body.removeChild(tempTextArea);
        }
      };


    const row = users?.map((user, index) => {
        return (
                <tr key={index}>
                    <td>{ currentPage === 1 ? currentPage + index : (((itemsPerPage*currentPage)-itemsPerPage)+1) + index }</td>
                    <td>{ user.roles.some((role: string) => TRTTotalRoles.includes(role)) 
                        ? user.firstName + " " + user.lastName
                        : user.fullName }</td>
                    <td><span onClick={() => handleCopy(user.email)} className="material-symbols-outlined mr-2" style={{fontSize: "16px", cursor: "pointer"}}>content_copy</span>
                        { user.email }</td>
                    <td>{ addSpacesToPascalCase(user.roles.join(', ')) }</td>
                    <td>{ user.roles.some((role: string) => TRTTotalRoles.includes(role)) 
                        ? "TEPNG" 
                        : "THIRD PARTY" }</td>
                    <td className="actions">
                        <button className="custom-button orange-outline"
                            onClick={() => {handleOpenModal("updateUserRoleModal"); getUser(user.id); setFormData({...formData, objectUserId: user.id, email: user.email})}}
                            >Update Role</button>
                        {/* <div className="dropdown">
                            <button className="dropbtn-2"><span className="material-symbols-outlined" style={{fontSize: "24px"}}>more_horiz</span></button>
                            <div className="dropdown-content">
                                <button
                                disabled={!user.isEnabled}
                                onClick={() => {handleOpenModal("UpdateUserModal"); getUser(user.id)}}
                                >View/Edit</button>

                                {user.isEnabled && <button
                                disabled={!user.isEnabled}
                                onClick={() => {handleOpenModal("ToggleActiveUser"); setActivity("deactivate"); setUserId(user.id)}}
                                >Deactivate</button>}

                                {!user.isEnabled && <button
                                disabled={user.isEnabled}
                                onClick={() => {handleOpenModal("ToggleActiveUser"); setActivity("activate"); setUserId(user.id)}}
                                >Activate</button>}

                                <button
                                onClick={() => {handleOpenModal("DeleteUser"); setUserId(user.email)}}
                                // disabled={!user.isEnabled || userDetails?.email === user?.email}
                                // title={userDetails?.email === user?.email ? "You cannot delete the current user" : ""}
                                >Delete</button>
                            </div>
                        </div> */}
                    </td>
                </tr>
        )
    })

    const handleSearch = (event: any) => {
        const value = event.target.value
        if(!value) setSearchValue("")
    }
    useEffect(() => {
        if(!searchValue) setUsers([])
    }, [searchValue])

    useEffect(() => {
        getAllUsers() // eslint-disable-next-line
    }, [currentPage, itemsPerPage, searchValue, filterRoleValue])

    // const [usersList, setUsersList] = useState([])
    // const getAllTotalEnergiesUsers = () => {        
    //     var request: Record<string, any> = {
    //         what: "getAllTotalEnergiesUsers",
    //         params: {}
    //     };

    //     makeGetRequest(request)
    //         .then((response: any) => {
    //             const res = response.data.data
    //             const formattedRecords = res.map((record: any) => {
    //                 return {label: `${record.firstName} ${record.lastName} - ${record.email}`, 
    //                 value: record.email, 
    //                 firstName: record.firstName, 
    //                 lastName: record.lastName,
    //                 department: `${record.department}; ${record.userId}`}
    //             })
                
    //             setUsersList(formattedRecords)
    //         })
    //         .catch((error:any) => 
    //             {toast.error(error);}
    //         );
    // }

    const [vendorList, setVendorList] = useState([])
    const getVendorByCompanyName = (vendorName: string) => {        
        var request: Record<string, any> = {
            what: "getVendorByCompanyName",
            vendorName: vendorName
        };

        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                const formattedRecords = res.map((record: any) => {
                    return {
                        label: record.vendorName, 
                        value: record.vendorName, 
                        emails: record.emails, 
                        address: record.address,
                        vendorCode: record.vendorCode}
                })
                
                setVendorList(formattedRecords)
            })
            .catch((error:any) => 
                {toast.error(error);}
            );
    }

    const HandleRemoveUserRole = (role: string) => {    
            setIsLoading2(true)               
            let data:any = {
                UserObjectId: formData.objectUserId,
                RoleName: role
            }
            
            var request:Record<string, any> = {
                what: "RemoveUserFromRole",
                data: data,
                params: {}
            };             
            makePostRequest(request)
                .then((response: any) => {    
                    setIsLoading2(false)                 
                    toast.success(response.msg)
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);
                })
                .catch((error:any) => {toast.error(error.msg); setIsLoading2(false) });
        } 
        
        const HandleAddUserRole = (role: string) => {    
            setIsLoading2(true)               
            let data:any = {
                UserEmail: formData.email,
                RoleName: role
            }
            
            var request:Record<string, any> = {
                what: "AddUserToRole",
                data: data,
                params: {}
            };             
            makePostRequest(request)
                .then((response: any) => {    
                    setIsLoading2(false)                 
                    toast.success(response.msg) 
                    setTimeout(() => {
                        window.location.reload()
                    }, 500);                    
                })
                .catch((error:any) => {toast.error(error.msg); setIsLoading2(false) });
        } 

    const [usersList, setUsersList] = useState([])
    const getAllTotalEnergiesUsers = (search: string) => {        
        var request: Record<string, any> = {
            what: "getAllTotalEnergiesUsers",
            params: {
                searchTerm: search
            }
        };

        makeGetRequest(request)
            .then((response: any) => {
                const res = response.data.data
                const formattedRecords = res.map((record: any) => {
                    return {label: `${record.firstName} ${record.lastName} - ${record.email}`, value: record.email, name: `${record.firstName} ${record.lastName}`}
                })
                
                setUsersList(formattedRecords)
            })
            .catch((error:any) => 
                {toast.error(error);}
            );
    }

    useEffect(() => {
        getAllRoles();
        // getAllTotalEnergiesUsers()
    }, [])   

    const page = "User Management"

    return (
        <Layout title={page}>
            <div className="container">
                <div className="main">
                    <h3 className="page_title">{  }</h3>     
                    <div className="main-inner">
                        <div className="main-inner-top">
                            <div className="d-flex gap-2">
                                <div className="search-container">
                                    <span className="material-symbols-rounded">search</span>
                                    <input id="search" placeholder="Search Users" onKeyUp={handleSearch} />
                                </div>
                                <button className="custom-button orange" disabled={isLoading}
                                    onClick={() => {setSearchValue((document.getElementById("search") as HTMLInputElement)?.value); setCurrentPage(1)}}
                                >{isLoading ? "Searching..." : "Search"}</button>
                            </div>

                            <select value={filterRoleValue} className='right-item' onChange={(e) => setFilterRole(e.target.value)} >
                                <option key="0" value="">All Roles</option>
                                {
                                    TRTRoles.map((role, index) => {
                                        return (
                                            <option key={index} value={role}>{addSpacesToPascalCase(role)}</option>
                                        )
                                    })
                                }
                            </select>
                            {/* <select className='right-item' id='category' value={filterCategoryValue} onChange={(e) => setFilterCategory(e.target.value)}>
                                <option key="0" value="">All Category</option>
                                <option key="1" value="TEPNG">TEPNG Staff</option>
                                <option key="2" value="THIRDPARTY">Third-Party User</option>
                            </select> */}
                            <button className="custom-button orange ml-2" onClick={() => handleOpenModal("CreateUserModal")}>
                                <span className="material-symbols-rounded">person</span>Onboard User
                            </button>
                        </div>                        

                        <div className='table-container custom'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>SN</th>
                                        <th style={{width: "200px"}}>Name</th>
                                        <th>Official Email</th>                                        
                                        <th>Role</th>
                                        <th>Category</th>
                                        <th style={{width: "80px"}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {isLoading ? null : (
                                        !users?.length ? <td className='no-records' colSpan={7}>{!searchValue ? "Search users to filter table" : "No Records Found"}</td>
                                        : row
                                    )
                                }
                                </tbody>
                            </table>
                            {isLoading ? <div className="loader">
                                        <img src={loading} alt="loading" />
                                        <p>Loading data...</p>
                                    </div> : null}
                        </div>

                        <div className="pagination-container">
                            <Pagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            itemsPerPage={itemsPerPage}
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            setCurrentPage={setCurrentPage}
                            getPageNumbers={getPageNumbers}
                            setItemsPerPage={setItemsPerPage}
                            startIndex={startIndex} />
                        </div> 
                    </div>                 
                </div>
            </div>
            {/* New User */}
            <Modal isOpen={CreateUserModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Onboard User</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("CreateUserModal")}>close</span>
                </div>                

                <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                    <div>
                        <label><span className="errorX mr-2">*</span>Email Address <span className="text-blue">(Enter email to search)</span></label>
                        <Autocomplete             
                            // name="requesterGeneralManagerEmail"                                          
                            filterOptions={filterOptions}                            
                            disableClearable={true}
                            onChange={(e, option:any) => setFormData({...formData, 'email': option.value, 'fullname': option.name})}
                            isOptionEqualToValue={(option: any, value: any) => option.value === value.value}
                            onInputChange={(event, value, search) => {
                                if (search === 'input') {
                                    getAllTotalEnergiesUsers(value);
                                }
                            }} 
                            options={usersList}                            
                            className='mt-1'                            
                            renderInput={(params) => 
                                <TextField placeholder='Select...' variant='outlined' {...params} />} />
                    </div>
                    <div className='mt-2'>
                        <label>Name</label>
                        <input type='text' disabled value={formData?.fullname} />
                    </div>

                    <div className='mt-2'>
                        <label><span className="errorX mr-2">*</span>Role</label>                        
                        <select className='mb-2' onChange={(event) => HandleAddUserRole(event.target.value)} disabled={isSubmitting || !formData?.email}>
                            <option>Select...</option>
                            {                            
                                TRTRoles?.map((role: any, index: any) => (
                                    <option disabled={window.location.pathname.split('/')[1] === role.toLocaleLowerCase()} value={role} key={index}>{addSpacesToPascalCase(role)}</option>
                                ))
                            }
                        </select>
                        <p className='alert alert-info m-0'>
                            User would be added automatically after selection and other roles can be added by searching and updating the user role.
                        </p>
                        {
                            selectedValue?.map((role: string) => {
                                return (
                                    <div className='switch-roles for-role' title={window.location.pathname.split('/')[1] === role.toLocaleLowerCase() ? "You're currently logged into this role" : ""}>
                                        <span>{addSpacesToPascalCase(role)}</span>                                
                                        {TRTRoles.includes(role)&&
                                        <button disabled={window.location.pathname.split('/')[1] === role.toLocaleLowerCase()} className='custom-button red-outline' onClick={() => HandleRemoveUserRole(role)}>Remove</button>    }                       
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </Modal>
            {/* Update User */}
            <Modal isOpen={updateUserRoleModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Update User Role</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("updateUserRoleModal")}>close</span>
                </div>
                <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                    {/* <p className='alert alert-info m-0'>
                    Kindly refresh the page after making any changes for them to reflect.
                    </p> */}
                    <p className='f-11 m-0 mt-2'>Select Role to Add</p>
                    <select className='mb-2' onChange={(event) => HandleAddUserRole(event.target.value)} disabled={isSubmitting}>
                        <option>Select...</option>
                        {                            
                            TRTRoles?.map((role: any, index: any) => (
                                <option disabled={window.location.pathname.split('/')[1] === role.toLocaleLowerCase()} value={role} key={index}>{addSpacesToPascalCase(role)}</option>
                            ))
                        }
                    </select>
                    {
                        selectedValue?.map((role: string) => {
                            return (
                                <div className='switch-roles for-role' title={window.location.pathname.split('/')[1] === role.toLocaleLowerCase() ? "You're currently logged into this role" : ""}>
                                    <span>{addSpacesToPascalCase(role)}</span>                                
                                    {TRTRoles.includes(role)&&
                                    <button disabled={window.location.pathname.split('/')[1] === role.toLocaleLowerCase()} className='custom-button red-outline' onClick={() => HandleRemoveUserRole(role)}>Remove</button>    }                       
                                </div>
                            )
                        })
                    }
                </div>
            </Modal>

            <Modal isOpen={CreateUserModal1} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Onboard User</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("CreateUserModal1")}>close</span>
                </div>
                <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                    <div className="d-flex gap-2" style={{alignItems: "start"}}>
                        <div className="w-50">
                            <label><span className="errorX mr-2">*</span>Category</label>
                            <select name='category' value={formData.category} onChange={handleChange}>
                                <option value="" key="0" disabled>Select Category</option>
                                <option value="TEPNG" key="1">TotalEnergies Staff</option>
                                <option value="THIRDPARTY" key="2">Third-Party User</option>
                            </select>
                            <p className="error">{ errorData.category }</p>
                        </div>
                        <div className="w-50">
                            <label><span className="errorX mr-2">*</span>Roles 
                            <span className='small-text'> (Multi-Choice)</span>
                            </label>  
                                <FormControl sx={{p: 0, mt: 1 }}>
                                    <Select
                                    multiple
                                    style={{width: "235px", borderRadius: "6px", margin: "0", fontSize: "12px"}}
                                    disabled={formData.category === ""}
                                    displayEmpty
                                    value={selectedValue}
                                    onChange={(event) => {
                                        const {
                                            target: { value },
                                        } = event;
                                        setSelectedValue(
                                            // On autofill we get a stringified value.
                                            typeof value === 'string' ? value.split(',') : value
                                        );
                                    }}
                                    input={<OutlinedInput />}
                                    renderValue={(selected) => {
                                        if (selected.length === 0) {
                                        return <em>Select...</em>;
                                        }

                                        return selected.join(', ');
                                    }}
                                    // MenuProps={MenuProps}
                                    inputProps={{ 'aria-label': 'Without label' }}
                                    >
                                    <MenuItem disabled value="" style={{fontSize: "12px"}}>
                                        <em>Select Role</em>
                                    </MenuItem>
                                    {roles
                                        ?.filter(role => 
                                            (formData.category === "TEPNG" ? TRTTotalRoles : TRTThirdPartyRoles).includes(role.name)
                                        )
                                        .map(role => (
                                            <MenuItem
                                            key={role.id}
                                            value={role.name}                                            
                                            style={{ fontSize: "12px", padding: "8px !important" }}
                                            >
                                            {role.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            <p className="error">{ errorData.role }</p>
                        </div>                            
                    </div>   

                    {formData.category === "THIRDPARTY" && 
                    <>
                        <label><span className="errorX mr-2">*</span>Company Name</label>
                        <Autocomplete      
                            onKeyUp={(e: any) => getVendorByCompanyName(e.target.value)}       
                            filterOptions={filterOptions}                            
                            disableClearable={true}
                            onChange={(e, option:any) => 
                                setFormData({...formData, 
                                'companyName': option.value, 
                                'firstName': option.value, 
                                'lastName': option.value, 
                                'vendorCode': option.vendorCode, 
                                'emails': option.emails,
                                'address': option.address })
                            }
                            isOptionEqualToValue={(option: any, value: any) => option.value === value.value}
                            options={vendorList}  
                            className='mt-1'                            
                            renderInput={(params) => 
                                <TextField placeholder='Select...' variant='outlined' {...params} />} />        
                        <p className="error">{ errorData.companyName }</p>
                    </>} 

                    {formData.category === "THIRDPARTY" &&
                    <>
                    <label><span className="errorX mr-2">*</span>Vendor Code</label>
                    <input name="vendorCode" value={formData.vendorCode} 
                        disabled
                        onChange={handleChange} 
                        onKeyUp={() => {
                            formData.vendorCode.length < 1 ? setErrorData({ ...errorData, vendorCode: 'This field is required' }) : 
                            setErrorData({ ...errorData, vendorCode: '' })}} />                        
                    <p className="error">{ errorData.vendorCode }</p>                   
                    </>}  

                    {formData.category && <label><span className="errorX mr-2">*</span>Official Email</label>}
                    {/* {formData.category === "TEPNG" && <Autocomplete             
                            filterOptions={filterOptions}                            
                            disableClearable={true}
                            disabled={!formData.roleIds.length}
                            onChange={(e, option:any) => setFormData({...formData, 
                                'email': option.value, 
                                'firstName': option.firstName, 
                                'lastName': option.lastName,
                                'department': option.department })}
                            isOptionEqualToValue={(option: any, value: any) => option.value === value.value}
                            options={usersList}                            
                            className='mt-1'                            
                            renderInput={(params) => 
                                <TextField placeholder='Select...' variant='outlined' {...params} />} /> }                      */}
                    
                    {formData.category === "THIRDPARTY" && 
                        <select name='email' value={formData.email} onChange={handleChange}>
                            <option value="" key="0" disabled>Select Email</option>
                            {formData.emails?.split(",").map((email: any) => (
                                <option value={email} key={email}>{email}</option>
                            ))}
                        </select>
                    }  
                    <p className="error">{ errorData.email }</p>

                    {/* Only show when not THIRDPARTY */}
                    {formData.category === "TEPNG" && <div className="d-flex gap-2">
                        <div>
                            <label><span className="errorX mr-2">*</span>First Name</label>
                            <input name="firstName" value={formData.firstName} 
                                disabled={!formData.roleIds?.length || formData.category === "TEPNG" }
                                onChange={handleChange} 
                                onKeyUp={() => {
                                    formData.firstName.length < 1 ? setErrorData({ ...errorData, firstName: 'This field is required' }) : 
                                    setErrorData({ ...errorData, firstName: '' })}} />
                            <p className="error">{ errorData.firstName }</p>
                        </div>
                        <div>
                            <label><span className="errorX mr-2">*</span>Last Name</label>
                            <input name="lastName" value={formData.lastName} 
                                disabled={!formData.roleIds?.length || formData.category === "TEPNG"}
                                onChange={handleChange} 
                                onKeyUp={() => {
                                    formData.lastName.length < 1 ? setErrorData({ ...errorData, lastName: 'This field is required' }) : 
                                    setErrorData({ ...errorData, lastName: '' })}} />
                            <p className="error">{ errorData.lastName }</p>
                        </div>
                    </div>}
                    
                    {/* <label><span className="errorX mr-2">*</span>Department</label>
                    <input name="department" value={formData.department} 
                        disabled={true}
                        onChange={handleChange} 
                        onKeyUp={() => {
                            formData.department.length < 1 ? setErrorData({ ...errorData, department: 'This field is required' }) : 
                            setErrorData({ ...errorData, department: '' })}} />                        
                    <p className="error">{ errorData.department }</p>                            */}
                </div>
                {/* <p className="or-text">or</p> */}
                <div className="modal-footer bt-1">
                    <button className="custom-button grey-outline"
                        onClick={() => handleCloseModal("CreateUserModal1")}>Cancel</button>
                    <button disabled={isSubmitting} type="submit" className="custom-button orange"
                        onClick={() => {}}>{isSubmitting ? "Loading..." : "Submit"}</button>
                </div>
            </Modal>

            <Modal isOpen={updateUserModal} style={customStyles} className="modal modal-5" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Edit User</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("UpdateUserModal")}>close</span>
                </div>
                <div className="modal-body" style={{maxHeight: "400px", overflowY: "auto"}}>
                    <div className="d-flex">
                        <div className="mr-2 w-50">
                            <label><span className="errorX mr-2">*</span>Category</label>
                            <select name='category' value={formData.category} onChange={handleChange}>
                                <option value="" key="0" disabled>Select Category</option>
                                <option value="TEPNG" key="1">TotalEnergies Staff</option>
                                <option value="THIRDPARTY" key="2">Third-Party User</option>
                            </select>
                            <p className="error">{ errorData.category }</p>
                        </div>
                        <div className="ml-2 w-50">
                            <label><span className="errorX mr-2">*</span>Roles 
                            <span className='small-text'> (Multi-Choice)</span>
                            </label>  
                            <FormControl sx={{p: 0, mt: 1 }}>
                                <Select
                                multiple
                                style={{width: "235px", borderRadius: "6px", margin: "0", fontSize: "12px"}}
                                disabled={formData.category === ""}
                                displayEmpty
                                value={selectedValue}
                                onChange={(event) => {
                                    const {
                                        target: { value },
                                    } = event;
                                    setSelectedValue(
                                        // On autofill we get a stringified value.
                                        typeof value === 'string' ? value.split(',') : value
                                    );
                                }}
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                    if (selected.length === 0) {
                                    return <em>Select...</em>;
                                    }

                                    return selected.join(', ');
                                }}
                                // MenuProps={MenuProps}
                                inputProps={{ 'aria-label': 'Without label' }}
                                >
                                <MenuItem disabled value="" style={{fontSize: "12px"}}>
                                    <em>Select Role</em>
                                </MenuItem>
                                {roles
                                    ?.filter(role => 
                                        (formData.category === "TEPNG" ? TRTTotalRoles : TRTThirdPartyRoles).includes(role.name)
                                    )
                                    .map(role => (
                                        <MenuItem
                                        key={role.id}
                                        value={role.name}                                            
                                        style={{ fontSize: "12px", padding: "8px !important" }}
                                        >
                                        {role.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>                            
                            <p className="error">{ errorData.eRole }</p>
                        </div>                            
                    </div>
                    <label><span className="errorX mr-2">*</span>Official Email</label>
                    <input name="email" value={formData.email} 
                        disabled={true}
                        onChange={handleChange} 
                        onKeyUp={() => {
                            formData.email.length < 1 ? setErrorData({ ...errorData, email: 'This field is required' }) : 
                            setErrorData({ ...errorData, email: '' })}} />                        
                    <p className="error">{ errorData.email }</p> 

                    {formData.category === "THIRDPARTY" &&
                    <>
                    <label><span className="errorX mr-2">*</span>Company Name</label>
                    <input name="companyName" value={formData.companyName} 
                        disabled/>                        
                    <p className="error">{ errorData.companyName }</p>

                    {/* <label><span className="errorX mr-2">*</span>Company Address</label>
                    <input name="address" value={formData.address} 
                        disabled/>                        
                    <p className="error">{ errorData.address }</p> */}

                    <label><span className="errorX mr-2">*</span>Vendor Code</label>
                    <input name="vendorCode" value={formData.vendorCode} 
                        disabled={true}
                        onChange={handleChange} 
                        onKeyUp={() => {
                            formData.vendorCode.length < 1 ? setErrorData({ ...errorData, vendorCode: 'This field is required' }) : 
                            setErrorData({ ...errorData, vendorCode: '' })}} />                        
                    <p className="error">{ errorData.vendorCode }</p>
                    </>}  

                    {formData.category === "TEPNG" && <div className="d-flex">
                        <div className="mr-2">
                            <label><span className="errorX mr-2">*</span>First Name</label>
                            <input name="firstName" value={formData.firstName} 
                                disabled={!formData.roleIds.length || formData.category === "TEPNG"}
                                onChange={handleChange} 
                                onKeyUp={() => {
                                    formData.firstName.length < 1 ? setErrorData({ ...errorData, firstName: 'This field is required' }) : 
                                    setErrorData({ ...errorData, firstName: '' })}} />
                            <p className="error">{ errorData.firstName }</p>
                        </div>
                        <div className="ml-2">
                            <label><span className="errorX mr-2">*</span>Last Name</label>
                            <input name="lastName" value={formData.lastName} 
                                disabled={!formData.roleIds.length || formData.category === "TEPNG"}
                                onChange={handleChange} 
                                onKeyUp={() => {
                                    formData.lastName.length < 1 ? setErrorData({ ...errorData, lastName: 'This field is required' }) : 
                                    setErrorData({ ...errorData, lastName: '' })}} />
                            <p className="error">{ errorData.lastName }</p>
                        </div>
                    </div>}

                </div>
                {/* <p className="or-text">or</p> */}
                <div className="modal-footer bt-1">
                    <button className="custom-button grey-outline"
                        onClick={() => handleCloseModal("UpdateUserModal")}>Cancel</button>
                    <button disabled={isSubmitting} type="submit" className="custom-button orange"
                        onClick={() => HandleEditUser()}>{isSubmitting ? "Loading..." : "Update"}</button>
                </div>
            </Modal>            

            <Modal
                isOpen={isLoading2}
                style={customStyles}
                className="modal modal-sm"
                ariaHideApp={false}
                >
                <div className="loader">
                    <img src={loading} alt="loading" />
                    <p>Loading data...</p>
                </div>
                </Modal>

            <Modal isOpen={toggleActiveUser} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Are you sure you want to {activity} this user?</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("ToggleActiveUser")}>close</span>
                </div>
                <div className="modal-footer">
                    <button className="custom-button grey-outline"
                        onClick={() => handleCloseModal("ToggleActiveUser")}>Cancel</button>
                    <button disabled={isSubmitting} type="submit" className="custom-button orange"
                        onClick={() => ActivateDeactivateUser()}>{isSubmitting ? "Loading..." : "Yes"}</button>
                </div>
            </Modal> 

            <Modal isOpen={deleteUserModal} style={customStyles} className="modal modal-3" ariaHideApp={false}>
                <div className="modal-header">
                    <h3>Are you sure you want to delete this user?</h3>
                    <span className="material-symbols-rounded close"
                        onClick={() => handleCloseModal("DeleteUser")}>close</span>
                </div>
                <div className="modal-footer">
                    <button className="custom-button grey-outline"
                        onClick={() => handleCloseModal("DeleteUser")}>Cancel</button>
                    <button disabled={isSubmitting} type="submit" className="custom-button orange"
                        onClick={() => DeleteUser()}>{isSubmitting ? "Loading..." : "Yes"}</button>
                </div>
            </Modal> 
            <ToastContainer />
        </Layout>
    )
}

export default UserManagement